import _definePage_default_0 from '/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/[...error].vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/login.vue?definePage&vue'

export const routes = [
  {
    path: '/',
    name: 'root',
    component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/index.vue'),
    /* no children */
  },
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  {
    path: '/account-settings',
    name: 'account-settings',
    component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/account-settings.vue'),
    /* no children */
  },
  {
    path: '/butler-chat',
    /* internal name: 'butler-chat' */
    /* no component */
    children: [
      {
        path: '',
        name: 'butler-chat',
        component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/butler-chat/index.vue'),
        /* no children */
      },
      {
        path: 'settings',
        name: 'butler-chat-settings',
        component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/butler-chat/settings.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/chain-configuration',
    /* internal name: 'chain-configuration' */
    /* no component */
    children: [
      {
        path: 'application',
        /* internal name: 'chain-configuration-application' */
        /* no component */
        children: [
          {
            path: '',
            name: 'chain-configuration-application',
            component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/chain-configuration/application/index.vue'),
            /* no children */
          },
          {
            path: 'form',
            name: 'chain-configuration-application-form',
            component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/chain-configuration/application/form.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'hotel-chain',
        /* internal name: 'chain-configuration-hotel-chain' */
        /* no component */
        children: [
          {
            path: '',
            name: 'chain-configuration-hotel-chain',
            component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/chain-configuration/hotel-chain/index.vue'),
            /* no children */
          },
          {
            path: 'form',
            name: 'chain-configuration-hotel-chain-form',
            component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/chain-configuration/hotel-chain/form.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'organization',
        /* internal name: 'chain-configuration-organization' */
        /* no component */
        children: [
          {
            path: '',
            name: 'chain-configuration-organization',
            component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/chain-configuration/organization/index.vue'),
            /* no children */
          },
          {
            path: 'form',
            name: 'chain-configuration-organization-form',
            component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/chain-configuration/organization/form.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/client-configuration',
    /* internal name: 'client-configuration' */
    /* no component */
    children: [
      {
        path: '',
        name: 'client-configuration',
        component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/client-configuration/index.vue'),
        /* no children */
      },
      {
        path: 'brand',
        /* internal name: 'client-configuration-brand' */
        /* no component */
        children: [
          {
            path: '',
            name: 'client-configuration-brand',
            component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/client-configuration/brand/index.vue'),
            /* no children */
          },
          {
            path: 'form',
            name: 'client-configuration-brand-form',
            component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/client-configuration/brand/form.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'hotel',
        /* internal name: 'client-configuration-hotel' */
        /* no component */
        children: [
          {
            path: '',
            name: 'client-configuration-hotel',
            component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/client-configuration/hotel/index.vue'),
            /* no children */
          },
          {
            path: 'form',
            name: 'client-configuration-hotel-form',
            component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/client-configuration/hotel/form.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'membership',
        /* internal name: 'client-configuration-membership' */
        /* no component */
        children: [
          {
            path: 'loyalty-program',
            /* internal name: 'client-configuration-membership-loyalty-program' */
            /* no component */
            children: [
              {
                path: '',
                name: 'client-configuration-membership-loyalty-program',
                component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/client-configuration/membership/loyalty-program/index.vue'),
                /* no children */
              },
              {
                path: 'form',
                name: 'client-configuration-membership-loyalty-program-form',
                component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/client-configuration/membership/loyalty-program/form.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'member-list',
            /* internal name: 'client-configuration-membership-member-list' */
            /* no component */
            children: [
              {
                path: '',
                name: 'client-configuration-membership-member-list',
                component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/client-configuration/membership/member-list/index.vue'),
                /* no children */
              },
              {
                path: 'form',
                name: 'client-configuration-membership-member-list-form',
                component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/client-configuration/membership/member-list/form.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'owner-list',
            /* internal name: 'client-configuration-membership-owner-list' */
            /* no component */
            children: [
              {
                path: '',
                name: 'client-configuration-membership-owner-list',
                component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/client-configuration/membership/owner-list/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'type',
            /* internal name: 'client-configuration-membership-type' */
            /* no component */
            children: [
              {
                path: '',
                name: 'client-configuration-membership-type',
                component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/client-configuration/membership/type/index.vue'),
                /* no children */
              },
              {
                path: 'form',
                name: 'client-configuration-membership-type-form',
                component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/client-configuration/membership/type/form.vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'promotion',
        /* internal name: 'client-configuration-promotion' */
        /* no component */
        children: [
          {
            path: '',
            name: 'client-configuration-promotion',
            component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/client-configuration/promotion/index.vue'),
            /* no children */
          },
          {
            path: 'form',
            name: 'client-configuration-promotion-form',
            component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/client-configuration/promotion/form.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/hotel-configuration',
    /* internal name: 'hotel-configuration' */
    /* no component */
    children: [
      {
        path: '',
        name: 'hotel-configuration',
        component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/hotel-configuration/index.vue'),
        /* no children */
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/login.vue'),
    /* no children */
  },
  _definePage_default_2
  ),
  {
    path: '/master-data',
    /* internal name: 'master-data' */
    /* no component */
    children: [
      {
        path: 'amenity',
        /* internal name: 'master-data-amenity' */
        /* no component */
        children: [
          {
            path: '',
            name: 'master-data-amenity',
            component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/master-data/amenity/index.vue'),
            /* no children */
          },
          {
            path: 'form',
            name: 'master-data-amenity-form',
            component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/master-data/amenity/form.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'featured-city',
        /* internal name: 'master-data-featured-city' */
        /* no component */
        children: [
          {
            path: '',
            name: 'master-data-featured-city',
            component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/master-data/featured-city/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/second-page',
    name: 'second-page',
    component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/second-page.vue'),
    /* no children */
  },
  {
    path: '/test-datatable-dropdown',
    name: 'test-datatable-dropdown',
    component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/test-datatable-dropdown.vue'),
    /* no children */
  },
  {
    path: '/test-dialog',
    name: 'test-dialog',
    component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/test-dialog.vue'),
    /* no children */
  },
  {
    path: '/test-dropdown',
    name: 'test-dropdown',
    component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/test-dropdown.vue'),
    /* no children */
  },
  {
    path: '/test-window',
    name: 'test-window',
    component: () => import('/codebuild/output/src2409875911/src/github.com/SentinelTech-com/sentec-membership-web/src/pages/test-window.vue'),
    /* no children */
  }
]
